<section class="take-off-drawing-actions-container">
    <button
        type="button"
        id="toShrinkToFit"
        class="btn btn-default mr-2"
        tooltip="Shrink to fit"
        placement="bottom"
        (click)="onCenterCanvas()">
        <i class="fa-light fa-arrow-up-right-and-arrow-down-left-from-center text-large"></i>
    </button>

    <div class="btn-group mr-2">
        <button
            *ngIf="config.canDrawShap"
            type="button"
            id="toPolygon"
            class="btn btn-shape"
            [ngClass]="{ active: config.shape === 'Polygon' }"
            tooltip="Polygon"
            placement="bottom"
            (click)="onChangeShape('Polygon')">
            <i class="fa fa-star text-large"></i>
        </button>
        <button
            *ngIf="config.canDrawShap"
            type="button"
            id="toRectangle"
            class="btn btn-shape"
            [ngClass]="{ active: config.shape === 'Rectangle' }"
            tooltip="Rectangle"
            placement="bottom"
            (click)="onChangeShape('Rectangle')">
            <i class="fa fa-square text-large"></i>
        </button>
        <button
            *ngIf="config.canDrawShap"
            type="button"
            id="toEllipse"
            class="btn btn-shape"
            [ngClass]="{ active: config.shape === 'Ellipse' }"
            tooltip="Ellipse"
            placement="bottom"
            (click)="onChangeShape('Ellipse')">
            <i class="fa fa-circle text-large"></i>
        </button>
        <button
            *ngIf="config.canDrawLine"
            type="button"
            id="toLine"
            class="btn btn-shape"
            [ngClass]="{ active: config.shape === 'Line' }"
            tooltip="Line"
            placement="bottom"
            (click)="onChangeShape('Line')">
            <i class="fa fa-minus text-large"></i>
        </button>
        <button
            *ngIf="config.canDrawPoint"
            type="button"
            id="toPoint"
            class="btn btn-shape"
            [ngClass]="{ active: config.shape === 'Point' }"
            tooltip="Point"
            placement="bottom"
            (click)="onChangeShape('Point')">
            <i class="far fa-dot-circle text-large"></i>
        </button>
    </div>

    <div class="mr-2 drawing-settings">
        <app-take-off-drawing-color-picker [selectedColor]="config.color" (colorChanges)="onColorChanged($event)">
        </app-take-off-drawing-color-picker>

        <app-take-off-pitch-dropdown
            *ngIf="config.canDrawLine"
            class="btn padding-0 take-off-pitch-dropdown"
            [degrees]="config.pitch"
            [ratio]="config.pitchRatio"
            (pitchChanged)="pitchChanged($event)">
        </app-take-off-pitch-dropdown>

        <button
            type="button"
            id="toDeduction"
            class="btn btn-shape"
            tooltip="Draws a deduction"
            placement="bottom"
            [ngClass]="{ active: config.negative }"
            (click)="onDeduct()">
            <i class="fa fa-minus-circle text-large"></i>
        </button>

        <button
            type="button"
            id="toToggleLabels"
            class="btn btn-shape"
            tooltip="Show/Hide shape labels"
            placement="bottom"
            [ngClass]="{ active: config.showLabels }"
            (click)="onToggleLabel()">
            <i class="fa fa-tag text-large"></i>
        </button>
    </div>
</section>
